module.exports = __webpack_public_path__ + "img/attendee.924cca8f.svg";